<template>
	<AppButton
		v-if="hasValue"
		variant="ghost"
		class="p-0"
		:title="tooltip"
		@click="handleClick"
	>
		<img
			:class="{ grayscale: !isActive, 'opacity-50': !isActive }"
			:src="sources[source].src"
			:alt="sources[source].alt"
			:title="tooltip ?? sources[source].alt"
			class="w-4 h-4 hover:opacity-100"
		/>
	</AppButton>
</template>

<script setup lang="ts">
import { isEqual } from "es-toolkit";
import { computed } from "vue";
import { sources } from "./dataSources";
import { usePropertyFieldOptional } from "./usePropertyField";

const props = defineProps<{
	value?: any;
	currentValue?: any;
	source: keyof typeof sources;
	onApply?: (value: any) => void;
	transformer?: (value: any) => any;
	tooltip?: string;
}>();

const context = usePropertyFieldOptional();

const hasValue = computed(() => {
	return props.value !== null && props.value !== undefined;
});

const transformedValue = computed(() => {
	return props.transformer ? props.transformer(props.value) : props.value;
});

const isActive = computed(() => {
	if (context && props.currentValue === undefined) {
		return context.isActive(transformedValue.value);
	}
	return isEqual(props.currentValue, transformedValue.value);
});

function handleClick() {
	if (props.onApply) {
		props.onApply(transformedValue.value);
	} else if (context) {
		context.setValue(transformedValue.value);
	}
}
</script>
